/*=====================================
    NewProductsView

    Author: Ac
    CreateTime: 2018 / 10 / 25
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import styled from 'styled-components';
import { GlobalStyle } from 'stylecomponents';
import NewsProductsGridItem from 'components/newproducts/commons/NewsProductsGridItem';
import productUtil, { PRODUCT_COVER_SIZE } from 'util/productUtil';

/*--------------------------
    Styled
--------------------------*/
const GridList = styled.ul`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 20px;
`;
/*--------------------------
    Main Component
--------------------------*/
class NewProductsView extends Component {

    componentDidMount() {

        const { isLoadedIdxPageInfo, isLoadingIdxPageInfo } = this.props;

        if(!isLoadedIdxPageInfo && !isLoadingIdxPageInfo)
            this.fetchIdxPageInfo();

    }

    fetchIdxPageInfo = () => {
        this.props.idxPageActions.getIdxPageInfo();
    }

    render() {

        const {
            newproducts = [],
            isLoadingIdxPageInfo,
            isLoadIdxPageInfoFailed,
        } = this.props;

        if(newproducts.length === 0) return null;

        return (
            <GlobalStyle.SubContainer>
                <GridList>
                    {
                        newproducts.map(product => {

                            const {
                                productid,
                                productname = '',
                                thumbimg,
                            } = product;

                            const imageSrc = productUtil.getProductCover(PRODUCT_COVER_SIZE.LARGE, productid, thumbimg);

                            return (
                                <NewsProductsGridItem
                                    key={productid}
                                    productName={productname.trim()}
                                    imageSrc={imageSrc}
                                    productId={productid}
                                    product={product}
                                />
                            );
                        })
                    }
                </GridList>
                {
                    isLoadingIdxPageInfo && (
                        <GlobalStyle.LoadingContainer>
                            <GlobalStyle.Spin />
                        </GlobalStyle.LoadingContainer>
                    )
                }
                {
                    isLoadIdxPageInfoFailed && (
                        <GlobalStyle.ErrorContainer>
                            <GlobalStyle.ErrorContainerTitle>
                                發生錯誤
                            </GlobalStyle.ErrorContainerTitle>
                            <GlobalStyle.ErrorContainerDesription>
                                無法取得列表，請重新整理後再嘗試。
                            </GlobalStyle.ErrorContainerDesription>
                        </GlobalStyle.ErrorContainer>
                    )
                }
            </GlobalStyle.SubContainer>
        );
    }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        newproducts: state.idxpage.newproducts,
        isLoadedIdxPageInfo: state.idxpage.isLoadedIdxPageInfo,
        isLoadingIdxPageInfo: state.idxpage.isLoadingIdxPageInfo,
        isLoadIdxPageInfoFailed: state.idxpage.isLoadIdxPageInfoFailed,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        idxPageActions: bindActionCreators(actionCreators.idxPageActionCreators, dispatch),
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(NewProductsView);